import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Modal, ModalBody, Button,
} from 'reactstrap';
import { downloadFile } from '../../utils/chatUtils';

function MediaPopup(props) {
  const {
    isOpen, onClose, timelineData, renderImageWithDownloadLink, renderVideoWithDownloadLink,
  } = props;

  const [modal, setModal] = useState(isOpen);

  const toggle = () => {
    setModal(!modal);
    onClose();
  };

  const hideModal = () => {
    toggle();
    onClose();
  };

  const downloadMedia = async (url) => {
    try {
      const urlParts = url.split('/');
      const name = urlParts[urlParts.length - 1];
      downloadFile(name, `${process.env.REACT_APP_API_URL.replace('graphql', '')}download?url=${url}`);
    } catch (error) {
      console.error(error);
    }
  };

  const renderMedia = () => {
    let data;
    if (timelineData.mediaType === 'image') {
      data = (
        <>
          {
            renderImageWithDownloadLink ? (
              <>
                <img src={timelineData.url} alt="media" />
                <div className="media-download-btn-group">
                  <Button
                    type="button"
                    color="primary"
                    onClick={() => downloadMedia(timelineData.url)}
                  >
                    download
                  </Button>
                </div>
              </>
            )
              : <img src={timelineData.url} alt="media" />
          }
        </>
      );
    } else if (timelineData.mediaType === 'video') {
      data = (
        renderVideoWithDownloadLink ? (
          <>
            <video autoPlay controls>
              <source src={timelineData.url} type="video/mp4" />
              <track src="captions_en.vtt" kind="captions" srcLang="en" label="english_captions" />
            </video>
            <div className="media-download-btn-group">
              <Button
                type="button"
                color="primary"
                onClick={() => downloadMedia(timelineData.url)}
              >
                download
              </Button>
            </div>
          </>
        )
          : (
            <video autoPlay controls>
              <source src={timelineData.url} type="video/mp4" />
              <track src="captions_en.vtt" kind="captions" srcLang="en" label="english_captions" />
            </video>
          )
      );
    }
    return data;
  };

  return (
    <Modal isOpen={modal} className="modal-create-beta-post modal-view">
      <ModalBody>
        <span
          onClick={hideModal}
          className="close"
        />
        <div className="full-media-view">
          {renderMedia()}
        </div>
      </ModalBody>
    </Modal>
  );
}

MediaPopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  timelineData: PropTypes.object.isRequired,
  renderImageWithDownloadLink: PropTypes.bool,
};

MediaPopup.defaultProps = {
  renderImageWithDownloadLink: false,
  renderVideoWithDownloadLink: false,
};
export default MediaPopup;
